import SEO from '../../components/seo/SEO'
import { breadcrumb } from '../../components/seo/jsonLd'

export default function Terms() {
  return (
    <>
      <SEO
        title="Terms of Service"
        description="The terms and conditions that govern bookings, payments, refunds and use of the Salon Vora website and services."
        path="/terms"
        jsonLd={breadcrumb([{ name: 'Home', url: '/' }, { name: 'Terms', url: '/terms' }])}
      />

      <article className="bg-white">
        <header className="bg-hero-gradient py-24 text-center">
          <div className="container-salon">
            <span className="section-tag !text-salon-secondary !bg-salon-secondary/15">Legal</span>
            <h1 className="font-display text-4xl md:text-5xl text-white font-bold mt-3">Terms of Service</h1>
            <p className="text-white/70 font-body mt-3">Last updated: January 2026</p>
          </div>
        </header>

        <div className="container-salon max-w-3xl py-16">
          <Section title="1. Acceptance of terms">
            By using salonvora.com or any Salon Vora service, you agree to these Terms. If you do not agree, please do not use our services.
          </Section>

          <Section title="2. Bookings & cancellations">
            <ul className="list-disc pl-5 space-y-1.5">
              <li>All appointments must be confirmed online or by phone.</li>
              <li>Free reschedule/cancellation up to 4 hours before the slot.</li>
              <li>Late cancellations or no-shows may forfeit any deposit paid.</li>
              <li>Bridal bookings require a non-refundable retainer fee.</li>
            </ul>
          </Section>

          <Section title="3. Payments & refunds">
            We accept UPI, cards, net banking and cash. Refunds for prepaid services are processed within 7–10 business days. Service refunds are at our discretion based on case-by-case review.
          </Section>

          <Section title="4. Patch tests & allergies">
            For chemical and colour services, you are required to inform us of any known allergies. A complimentary patch test is offered 48 hours before the service. Salon Vora is not liable for reactions where a patch test was declined.
          </Section>

          <Section title="5. Conduct">
            We reserve the right to refuse service to anyone behaving inappropriately toward our staff or other clients.
          </Section>

          <Section title="6. Intellectual property">
            All content on this site — text, photographs, logos, graphics — is owned by Salon Vora and may not be reproduced without permission.
          </Section>

          <Section title="7. Limitation of liability">
            Salon Vora's liability for any service is limited to the amount paid for that service. We are not liable for indirect or consequential damages.
          </Section>

          <Section title="8. Governing law">
            These terms are governed by the laws of India. Any dispute is subject to the exclusive jurisdiction of the courts in Chennai.
          </Section>

          <Section title="9. Contact">
            For questions about these terms, write to <a href="mailto:hello@salonvora.com" className="text-salon-primary underline">hello@salonvora.com</a>.
          </Section>
        </div>
      </article>
    </>
  )
}

function Section({ title, children }) {
  return (
    <section className="mb-8">
      <h2 className="font-display text-2xl font-semibold text-salon-dark mb-3">{title}</h2>
      <div className="text-salon-muted font-body leading-relaxed">{children}</div>
    </section>
  )
}
